"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRootContext = void 0;
var DateValidator_1 = require("./utils/DateValidator");
var RegexValidator_1 = require("./utils/RegexValidator");
var StringUtils_1 = require("./utils/StringUtils");
var arrayValidations_1 = __importDefault(require("./utils/arrayValidations"));
var timeUtils_1 = __importDefault(require("./utils/timeUtils"));
var dateTimeUtils = __importStar(require("./utils/DateTimeUtils"));
var f_1 = __importDefault(require("f"));
var publicInterface_1 = require("./utils/publicInterface");
var createRootContext = function (context) {
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign({ f: f_1.default, hasProperty: publicInterface_1.hasProperty, pageBreakP: '<w:p><w:br w:type="page" /></w:p>', pageBreak: '<w:br w:type="page" />', joinStrings: function (strArray, joinChar) {
            return !strArray ? '' : strArray.join(joinChar);
        }, isTruthy: function (value) { return Boolean(value); }, parseJSON: function (json) { return JSON.parse(json); }, stringifyJSON: function (obj) { return JSON.stringify(obj); }, OPEN_CURLY_BRACKET: '{', CLOSE_CURLY_BRACKET: '}' }, new DateValidator_1.DateValidator(context && context.options && context.options.dateFormat)), new RegexValidator_1.RegexValidator()), new StringUtils_1.StringUtils()), arrayValidations_1.default), timeUtils_1.default), dateTimeUtils), context);
};
exports.createRootContext = createRootContext;
//# sourceMappingURL=index.js.map